var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInformation = function SvgInformation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_7033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66771 4.66706C8.66771 5.03525 8.36923 5.33372 8.00104 5.33372C7.63285 5.33372 7.33437 5.03525 7.33437 4.66706C7.33437 4.29887 7.63285 4.00039 8.00104 4.00039C8.36923 4.00039 8.66771 4.29887 8.66771 4.66706Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00104 1.9334C4.65051 1.9334 1.93438 4.64954 1.93438 8.00007C1.93438 11.3506 4.65051 14.0667 8.00104 14.0667C11.3516 14.0667 14.0677 11.3506 14.0677 8.00007C14.0677 4.64954 11.3516 1.9334 8.00104 1.9334ZM0.734375 8.00007C0.734375 3.9868 3.98777 0.733398 8.00104 0.733398C12.0143 0.733398 15.2677 3.9868 15.2677 8.00007C15.2677 12.0133 12.0143 15.2667 8.00104 15.2667C3.98777 15.2667 0.734375 12.0133 0.734375 8.00007ZM6.73437 7.00039C6.73437 6.66902 7.003 6.40039 7.33437 6.40039H8.00104C8.33241 6.40039 8.60104 6.66902 8.60104 7.00039L8.60104 11.3334C8.60104 11.6648 8.33241 11.9334 8.00104 11.9334C7.66967 11.9334 7.40104 11.6648 7.40104 11.3334L7.40104 7.60039H7.33437C7.003 7.60039 6.73437 7.33176 6.73437 7.00039Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_7033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "information.202ce55d986f0ccfef6ba67e4a0dbe77.svg";